import * as React from "react";
import { SVGProps } from "react";
const SvgPasswordInvisible = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.707 5.293a1 1 0 0 1 0 1.414l-20 20a.996.996 0 0 1-1.414 0 1 1 0 0 1 0-1.414l4.073-4.072c-2.75-2.183-4.2-4.9-4.352-5.195L4 16s4-8 12-8c1.73 0 3.272.374 4.627.96l3.666-3.667a1 1 0 0 1 1.414 0Zm-2.072 5.487C26.545 13.09 28 16 28 16l-.003.007-.027.051-.053.1C27.306 17.278 23.334 24 16 24c-1.728 0-3.27-.373-4.626-.959l2.136-2.136a5.5 5.5 0 0 0 7.396-7.396l2.729-2.729Zm-4.266 4.267a3.503 3.503 0 0 1-4.322 4.322l4.322-4.322ZM16 10.5a5.502 5.502 0 0 0-4.905 7.991l1.537-1.536a3.503 3.503 0 0 1 4.323-4.323l1.536-1.537a5.478 5.478 0 0 0-2.49-.595H16Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPasswordInvisible;
